const TYPE = {
    SEA: "sea",
    DATA: "data",
    CITY: "city",
    THINGS: "things"
}
// {
//     img: require("@/assets/images/1-1.png"),
//         title: "水底地形展示平台",
//     key: "while",
//     type: [TYPE.SEA],
//     carouseImages: [
//     require("@/assets/images/1-1.png"),
//     require("@/assets/images/1-2.png"),
//     require("@/assets/images/1-3.png"),
// ],//走马灯图片
// },
export default [
    // {
    //     img: "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/1-1.png",
    //     title: "水底地形展示平台",
    //     key: "while",
    //     type: [TYPE.SEA],
    //     carouseImages: [
    //         "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/1-1.png",
    //         "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/1-2.png",
    //         "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/1-3.png",
    //     ],//走马灯图片
    //     carouselUrl: "http://121.40.248.247:9334/water-page?item=%257B%2522item_id%2522%253A%2522537399807040290819%2522%252C%2522project_id%2522%253A%2522537398104136089603%2522%257D"
    // },
    {
        img: "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/2-1.png",
        title: "桥梁数字孪生平台",
        key: "xihu",
        type: [TYPE.SEA, TYPE.CITY],
        carouseImages: [
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/2-1.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/2-4.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/2-2.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/2-3.png",
        ],
        carouselUrl: "http://121.40.248.247:9330/#/home-page"
    },
    {
        img: "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/3-1.png",
        title: "园林绿化数字化系统",
        key: "zhyl",
        type: [TYPE.CITY],
        carouseImages: [
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/3-1.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/3-2.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/3-3.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/3-4.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/3-5.png",
        ],
        carouselUrl: "http://121.40.248.247:9329/#/demo"
    },
    {
        img: "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/4-1.png",
        title: "古建筑数字孪生系统",
        key: "zssqf",
        type: [TYPE.CITY],
        carouseImages: [
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/4-1.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/4-2.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/4-3.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/4-4.png",
        ],
        carouselUrl: "http://120.26.195.192:5017/"
    },
    {
        img: "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/5-1.png",
        title: "智慧港航系统",
        key: "zhghxt",
        type: [TYPE.THINGS],
        carouseImages: [
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/5-1.png",
        ],
        carouselUrl: "http://121.40.248.247:9324/"
    },
    {
        img: "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/6-1.png",
        title: "船闸变形监测",
        key: "czbxjc",
        type: [TYPE.DATA],
        carouseImages: [
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/6-1.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/6-2.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/6-3.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/6-4.png",
        ],
        carouselUrl: "http://121.40.248.247:9331/"
    },
    {
        img: "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/7-1.png",
        title: "变形监测系统",
        key: "bl-bxjc",
        type: [TYPE.DATA],
        carouseImages: [
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/7-1.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/7-2.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/7-3.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/7-4.png",
        ],
        carouselUrl: "http://121.40.248.247:9332/#/demo"
    },
    {
        img: "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/8-1.png",
        title: "变形监测系统2",
        key: "ssl-bxjc",
        type: [TYPE.DATA],
        carouseImages: [
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/8-1.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/8-2.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/8-3.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/8-4.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/8-5.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/8-6.png",
        ],
        carouselUrl: "http://121.40.248.247:9333/"
    },
    {
        img: "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/9-1.png",
        title: "流速流向实时监测平台",
        key: "cbd",
        type: [TYPE.THINGS],
        carouseImages: [
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/9-1.png"
        ],
        carouselUrl: "http://121.40.248.247:9326/"
    },
    {
        img: "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/10-1.png",
        title: "交通路网平台",
        key: "pyzx",
        type: [TYPE.CITY],
        carouseImages: [
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/10-1.png",
        ],
        carouselUrl: "http://123.60.150.191/itms_gc/#/"
    },
    {
        img: "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/11-1.png",
        title: "智慧电箱",
        key: "zjdx",
        type: [TYPE.THINGS],
        carouseImages: [
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/11-1.png",
            // "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/11-2.png",
            // "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/11-3.png",
        ],
        carouselUrl: "http://121.40.248.247:9322/",
    },
    {
        img: "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/12-1.png",
        title: "智慧工地",
        key: "hsx",
        type: [TYPE.THINGS, TYPE.CITY],
        carouseImages: [
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/12-1.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/12-2.png",
        ],
        carouselUrl: "http://121.40.248.247:9328/"
    },
    {
        img: "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/13-1.png",
        title: "智慧交通工程管理系统",
        key: "zhjtglxt",
        type: [TYPE.CITY],
        carouseImages: [
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/13-1.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/13-2.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/3-3.png",
        ],
        carouselUrl: "http://123.60.150.191/pingyang/#/sy"
    },
    {
        img: "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/14-2.png",
        title: "水深展示系统",
        key: "sszs",
        type: [TYPE.SEA],
        carouseImages: [
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/14-1.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/14-2.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/14-3.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/14-4.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/14-5.png",
        ],
        carouselUrl: "http://121.40.248.247:9327/"
    },
    {
        img:"https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/15-1.png",
        title: "智慧园区",
        key: "zhyq",
        type: [TYPE.CITY],
        carouseImages: [
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/15-1.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/15-2.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/15-3.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/15-4.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/15-5.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/showweb/images/15-6.png",
        ],
        carouselUrl:"http://120.26.195.192:10100",
    },
    {
        img:"https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/%E4%BC%81%E4%B8%9A%E5%BE%AE%E4%BF%A1%E6%88%AA%E5%9B%BE_17726764072415.png",
        title: "桥梁GIS查询系统",
        key: "qlgiscxxt",
        type: [TYPE.SEA],
        carouseImages: [
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/%E4%BC%81%E4%B8%9A%E5%BE%AE%E4%BF%A1%E6%88%AA%E5%9B%BE_17726764072415.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/%E4%BC%81%E4%B8%9A%E5%BE%AE%E4%BF%A1%E6%88%AA%E5%9B%BE_20260305101028.png",
            "https://shgis.oss-cn-hangzhou.aliyuncs.com/whale/%E4%BC%81%E4%B8%9A%E5%BE%AE%E4%BF%A1%E6%88%AA%E5%9B%BE_1772676600345.png",
        ],
        carouselUrl:"http://121.40.248.247:9751",
    },

]